


























import Vue from 'vue';
import { ErrorUtils } from '@/utils';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { BackgroundExportNotificationLinkModel } from '@/services/GeneratedApi';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { DocumentExportService } from '@/services/DocumentExportService';
import { BvModalEvent } from 'bootstrap-vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
export default Vue.extend({
  name: 'BackgroundExportDownload',
  data() {
    return {
      showModal: false,
      exportStatus: '',
      cancelled: false
    };
  },
  props: {
    linkData: {
      type: Object as () => BackgroundExportNotificationLinkModel
    },
    actionIsDelete: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    async downloadZips(this: any) {
      this.showModal = true;
      let fileNumber = 1;
      do {
        if (this.cancelled) {
          return;
        }
        await this.downloadZip(fileNumber);
        fileNumber++;
      } while (fileNumber > 0 && fileNumber <= this.linkData.fileCount);

      this.showModal = false;
      await this.deleteExportAsync();
    },
    async downloadZip(this: any, fileNumber: number) {
      this.exportStatus = `Downloading zip file ${fileNumber} of ${this.linkData.fileCount}`;
      let filename = `${this.linkData.zipFilename}_${fileNumber}`;

      try {
        const response = await DocumentExportService.getExportZipFileAsync(this.linkData.id, fileNumber);
        const contentDisposition = response.headers['content-disposition'];
        const blobObject = new Blob([response.data]);
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+);/);
          if (fileNameMatch.length === 2) {
            filename = filename.concat('.', fileNameMatch[1].split('.').pop());
          }
        }
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blobObject, filename);
          return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        try {
          const errorModel = await ErrorUtils.getExceptionResponseModelFromBlob(error.response.data);
          SnotifyConfiguration.showNotification(errorModel.notification, errorModel.presentationType);
        } catch (error) {
          this.$log(error);
        }
      }
    },

    onCancel(this: any, bvModalEvent: BvModalEvent) {
      bvModalEvent.preventDefault();
      this.cancelled = true;
      this.$emit('link-action:completed');
      this.showModal = false;
    },
    async deleteExportAsync() {
      if (this.linkData.id === undefined) {
        this.$log('this.linkData.id is undefined');
        this.$emit('link-action:completed');
        return;
      }

      try {
        await ApiConfiguration.api().documentExport.documentExportBackgroundexportzipDelete(this.linkData.id);
      } catch (error) {
        this.$log(error);
      }

      this.$emit('link-action:completed');
    }
  },
  components: {
    LoadingSpinner
  },

  async mounted(this: any) {
    if (this.actionIsDelete) {
      await this.deleteExportAsync();
      return;
    }
    await this.downloadZips();
  }
});
